t = require('views/internal/teacup-with-helpers')('member_on_card_menu')

module.exports = ->
  t.mustacheBlock '__ed', ->
    t.li ->
      t.a '.js-remove-member', ->
        t.format 'remove-from-card'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_on_card_menu.coffee